import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NewProjectBaseSettingDTO } from '../../models/Project.model';
import { getNewProjectBaseSettings } from '../thunks/newProjectSettingsThunks';

interface NewProjectSettingsState {
  baseSettings: NewProjectBaseSettingDTO | null;
  loading: boolean;
  error: string | null;
}

const initialState: NewProjectSettingsState = {
  baseSettings: null,
  loading: false,
  error: null,
};

const newProjectSettingsSlice = createSlice({
  name: 'newProjectSettings',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNewProjectBaseSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNewProjectBaseSettings.fulfilled, (state, action: PayloadAction<NewProjectBaseSettingDTO>) => {
        state.loading = false;
        state.baseSettings = action.payload;
      })
      .addCase(getNewProjectBaseSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch base settings';
      });
  },
});

export const { clearError } = newProjectSettingsSlice.actions;
export default newProjectSettingsSlice.reducer;